export default "__VITE_ASSET__BO$BvzYl__"